import React, { Component } from 'react';


export default class Input extends Component {
    render() {
        const { name,classNameInput, type = 'text', value, onChange, label } = this.props;
        return (
            <div>
                <label htmlFor={name}>{label}</label>
                <input
                    className={classNameInput}
                    onChange={onChange}
                    name={name}
                    id={name}
                    type={type}
                    value={value} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/common/Input.jsx